import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class DashboardEnvironmentInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const dashboardEnvironment: string = environment.dashboardEnvironment;
        const isDemoAwareEndpoint = request.url.includes('dashboard-call/')
            || request.url.includes('auth/email-login-call')
            || request.url.includes('auth/google-login-call');

        if (dashboardEnvironment !== 'demo' || !isDemoAwareEndpoint) {
            return next.handle(request);
        }

        return next.handle(request.clone({
            setHeaders: {
                'x-dashboard-environment': dashboardEnvironment
            }
        }));
    }
}
